import { BasicInput } from '../withFormProps';
import React, { useEffect, useState } from 'react';
import { useCurrentStepIndex, useField, useForm } from '@kizi/comparator-core';

export type InitialsProps = {
  name: string;
};

export const Initials: React.FC<InitialsProps> = ({ name }) => {
  const initialsField = useField(name);
  const wizardStepIndex = useCurrentStepIndex() ?? '';
  const { send } = useForm(wizardStepIndex);
  if (!initialsField || !send) return null;
  const { value, errors, label, name: fieldNameInfix } = initialsField;

  const error = errors?.join('. ');

  const transformInitials = (v) => {
    if (!v) return v;
    return v
      .toString()
      .replace(/[^a-zA-Z]+/gi, '')
      .replace(/(.{1})/g, '$1.')
      .toUpperCase();
  };

  const [state, setState] = useState(transformInitials(value) ?? '');

  useEffect(() => {
    send?.({
      target: {
        name: initialsField.name,
        value: state,
      },
      type: 'CHANGE',
    });
  }, [state]);

  return (
    <BasicInput
      name={fieldNameInfix}
      _label={label}
      _error={error}
      onChange={(e) => setState(e.target.value)}
      onBlur={() => setState(transformInitials(state))}
      value={state}
    />
  );
};
